<template>
  <a-tabs v-model:activeKey="activeKey">
    <a-tab-pane key="1">
      <template #tab>
        <span>
          <i class="fas fa-list"></i>
        </span>
        <span class="tab-title">{{ $t('text.imageList') }}</span>
      </template>
      <GalaxyUpload :apiImages="props.apiImages" @choiceBanner="choiceBanner" />
    </a-tab-pane>
    <a-tab-pane key="2">
      <template #tab>
        <span>
          <i class="fas fa-upload"></i>
        </span>
        <span class="tab-title">{{ $t('text.uploadImage') }}</span>
      </template>
       <UploadFileImages @uploadImages="uploadImages" />
    </a-tab-pane>
  </a-tabs>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import UploadFileImages from "@/components/upload/UploadFileImages.vue";
import GalaxyUpload from "@/components/galaxy/Galaxy.vue";

interface Props {
  apiImages: any,
}

const props = withDefaults(defineProps<Props>(), {
  apiImages: '',
})

const activeKey = ref('1');
const emit = defineEmits(["close", "uploadImages", "choiceBanner"]);

const uploadImages = (images: any) => {
  emit("uploadImages", images);
};

const choiceBanner = (images: any) => {
  // clone tránh reactive side-effect
  const data = JSON.parse(JSON.stringify(images));
  emit("choiceBanner", data);
};
</script>
<style lang="css" scoped>
.tab-title {
  margin-left: 8px;
}
</style>